import React from 'react';

function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer id="location" className="bg-[#0a0a0a] border-t border-white/5 pt-20 pb-10 px-6 relative overflow-hidden">
      <div className="max-w-7xl mx-auto">

        {/* TOP SECTION: Location & Info Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 mb-20">

          {/* Info Panel */}
          <div className="bg-[#151515] p-8 md:p-12 rounded-2xl border border-[#333] shadow-2xl relative z-10">
            <h2 className="font-['Bebas_Neue'] text-5xl mb-2 text-white italic tracking-wider">
              PRIME EATS HQ
            </h2>
            <div className="h-1 w-24 bg-[#d4af37] mb-10"></div>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-8">
              <div className="mb-4">
                <p className="text-[10px] text-gray-500 uppercase tracking-[0.3em] mb-2 font-black">
                  Address
                </p>
                <p className="text-xl font-bold text-white leading-tight font-['Inter']">
                  417 S Wayne Rd,<br />
                  Westland, MI 48186
                </p>
              </div>

              <div className="mb-4">
                <p className="text-[10px] text-gray-500 uppercase tracking-[0.3em] mb-2 font-black">
                  Hotline
                </p>
                <a
                  href="tel:7342864221"
                  className="text-2xl font-bold text-[#d4af37] hover:text-white transition-colors font-['Bebas_Neue'] tracking-wide"
                >
                  (734) 286-4221
                </a>
              </div>
            </div>

            <div className="mt-8 pt-8 border-t border-white/5">
              <p className="text-[10px] text-gray-500 uppercase tracking-[0.3em] mb-4 font-black">
                Operating Hours
              </p>

              <div className="space-y-2 font-['Inter'] text-sm">
                <div className="flex justify-between border-b border-[#222] pb-2 text-gray-400">
                  <span>Sun - Thu</span>
                  <span className="text-[#d4af37] font-['Bebas_Neue'] text-lg">
                    12 PM – 10 AM
                  </span>
                </div>

                <div className="flex justify-between border-b border-[#222] pb-2 text-gray-400">
                  <span>Fri - Sat</span>
                  <span className="text-[#d4af37] font-['Bebas_Neue'] text-lg">
                    12 PM – 12 AM
                  </span>
                </div>
              </div>
            </div>
          </div>

          {/* Map Panel */}
          <div className="h-[400px] md:h-full min-h-[400px] rounded-2xl overflow-hidden border border-[#333] grayscale invert-[0.9] contrast-[1.2] relative">

            <iframe
              title="Location Map"
              width="100%"
              height="100%"
              frameBorder="0"
              src="https://maps.google.com/maps?q=42.30755898875856,-83.38781717116419&t=&z=15&ie=UTF8&iwloc=&output=embed"
              className="opacity-80"
            />

            {/* Get Directions Button (Overlay) */}
            <a
              href="https://www.google.com/maps/dir/?api=1&destination=42.30755898875856,-83.38781717116419"
              target="_blank"
              rel="noopener noreferrer"
              className="absolute bottom-4 right-4 bg-[#d4af37] hover:bg-yellow-400 text-black px-5 py-3 rounded-lg font-bold text-sm uppercase tracking-wide shadow-lg hover:shadow-xl transition-all font-['Bebas_Neue'] hover:scale-105 z-10"
            >
              Get Directions
            </a>

          </div>
        </div>

        {/* BOTTOM BAR */}
        <div className="flex flex-col md:flex-row items-center justify-between gap-8 pt-10 border-t border-white/5">
          <div className="text-center md:text-left">
            <p className="text-[10px] font-black text-white/20 uppercase tracking-[0.5em]">
              Prime Eats • Est. 2018 • Westland, MI
            </p>
            <p className="text-[9px] text-white/10 uppercase tracking-widest mt-1">
              © {currentYear} All Rights Reserved
            </p>
          </div>

          {/* CAFFRYX BADGE */}
          <a
            href="https://caffryx.com"
            target="_blank"
            rel="noopener noreferrer"
            className="bg-black text-white p-4 shadow-[5px_5px_0px_#d4af37] hover:shadow-none transition-all border border-[#222] flex flex-col group"
          >
            <span className="text-[8px] text-gray-500 uppercase font-black tracking-[0.2em] leading-none mb-1">
              Developed By
            </span>
            <span className="text-sm font-black uppercase tracking-tighter group-hover:text-[#d4af37] transition-colors leading-none font-['Inter']">
              Caffryx<span className="text-[#d4af37]">.</span>
            </span>
          </a>
        </div>

      </div>
    </footer>
  );
}

export default Footer;